export default "__VITE_ASSET__DtZFefo6__"